var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667L8.35355 11.0202C8.15829 11.2155 7.84171 11.2155 7.64645 11.0202L8 10.6667ZM11.6464 6.31313C11.8417 6.11787 12.1583 6.11787 12.3536 6.31313C12.5488 6.5084 12.5488 6.82498 12.3536 7.02024L11.6464 6.31313ZM3.64645 7.02024C3.45118 6.82498 3.45118 6.5084 3.64645 6.31313C3.84171 6.11787 4.15829 6.11787 4.35355 6.31313L3.64645 7.02024ZM7.64645 10.3131L11.6464 6.31313L12.3536 7.02024L8.35355 11.0202L7.64645 10.3131ZM7.64645 11.0202L3.64645 7.02024L4.35355 6.31313L8.35355 10.3131L7.64645 11.0202Z",
    fill: "#f7f7fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.481b12cf587755d6a5f36c1f1af246a9.svg";
export { ForwardRef as ReactComponent };